import { ExternalLinkAlt } from '@styled-icons/fa-solid';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { getUsersSkillsList } from '../../api/skillsMatrix';
import DataTable, { useDataTableHandle } from '../DataTable';
import { ShowIf } from '../Security/security';
import './SkillsMatrix.css';

const SkillsMatrix = () => {
  const navigate = useNavigate();
  const dth = useDataTableHandle();
  const [pagination, setPagination] = useState({ pageNo: 0, itemsPerPage: 10 });
  const hasPaginationLoaded = pagination.pageNo !== undefined && pagination.itemsPerPage !== undefined;

  const { sortStatus, filterStatus } = dth.current;
  const filter = filterStatus?.filterText ? filterStatus : {};

  const { isPending, data, error } = useQuery({
    queryKey: ['getUsersSkillsList', pagination, sortStatus, filter],
    queryFn: () =>
      getUsersSkillsList(pagination.pageNo * pagination.itemsPerPage, pagination.itemsPerPage, sortStatus, filter),
    enabled: hasPaginationLoaded,
  });
  const { data: skills, totalCount } = data || {};

  totalCount && typeof dth?.current?.setServerDataLength === 'function' && dth.current.setServerDataLength(totalCount);

  return (
    <div className="full-width-container skills-matrix">
      <section className="floating-box position-relative p-3" style={{ maxWidth: '1040px' }}>
        <div className="d-flex">
          <h1 className="pb-2">Skills Matrix</h1>
        </div>
        <div className="pb-4">
          <DataTable
            dontRefreshPagination
            idKey="id"
            data={skills || []}
            className="table-striped"
            lazyLoading
            showAdvnSearch // shows reset filters
            isLoading={isPending}
            persistGetter={pagination}
            persistSetter={setPagination}
            handle={dth}
            sortable
            filterable
            onUpdate={() => null}
          >
            <DataTable.Pagination itemsPerPage={[10, 25, 50]} className="w-100 d-flex justify-content-end" />
            <DataTable.Row style={{ fontSize: '14px' }} />
            <DataTable.Column colKey="firstname" header="First Name" />
            <DataTable.Column colKey="lastname" header="Last Name" />
            <DataTable.Column colKey="department" header="department" />
            <DataTable.Column colKey="access" header="access" />
            <DataTable.Column colKey="skilllevel" header="Skill Level" />
            <DataTable.Column header="View">
              {(item) => {
                if (!item.canEdit) {
                  return <ExternalLinkAlt width="1rem" height="1rem" style={{ color: '#CCC' }} />;
                }

                return (
                  <Link to={`/SkillsMatrix/${item.id}`}>
                    <ExternalLinkAlt width="1rem" height="1rem" />
                  </Link>
                );
              }}
            </DataTable.Column>
          </DataTable>
        </div>
        {error && (
          <div className={'pb-4 text-danger'}>
            <em>Unable to retrieve skills matrix users</em>
          </div>
        )}
        <Button variant="secondary" onClick={() => navigate(-1)}>
          Back
        </Button>
      </section>
    </div>
  );
};

export default SkillsMatrix;
